import React, { useEffect, useState } from 'react'
import './ZahtjevInputForm.css'
import { Form, Button, Col, Row, Spinner, InputGroup } from 'react-bootstrap'
import ServiceList from '../ServisList/ServisList'
import DocumentUpload from '../DocumentUpload/DocumentUpload'
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons'
import { SECRET_REGEX_PATTERN } from '../../api/utils/constants'

const ZahtjevInputForm = (props) => {

    const [passwordShown, setPasswordShown] = useState(false);
    const [counter, setCounter] = React.useState(0);

    useEffect(() => {
        // Za ID usluge u linku (npr. https://ospd.fina.hr/#5)
        const str = window.location.hash;
        const matches = str.match(/#(\d+)/);
        let idUsluge = null;
        let sifraGrupeFromLink = null;
        if (matches) {
            idUsluge = matches[1]
            sifraGrupeFromLink = props.uslugaGrupaList.find(group => group.uslugaList.some(usluga => usluga.idUsluge.toString() === idUsluge))?.sifraGrupe;
            let button = document.getElementById("grupa-" + sifraGrupeFromLink);
            if (button !== null) {
                button.click();
            }
        }
    }, [props.uslugaGrupaList])


    const togglePasswordVisiblity = () => {
        if (passwordShown) {
            setCounter(0);
        } else {
            setPasswordShown(true);
            setCounter(5);
        }
    };

    useEffect(() => {
        if (counter > 0 && passwordShown) {
            setTimeout(() => setCounter(counter - 1), 1000);
        } else {
            setPasswordShown(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counter]);

    let podruznicaOptions = props.podruznicaList.map((podruznica) => (
        <option value={podruznica.podruznicaId} key={podruznica.podruznicaId}>{podruznica.naziv}</option>
    ));

    return (
        <Form noValidate validated={props.validated} onSubmit={e => props.handleSubmit(e)}>
            <Row className="justify-content-md-center">
                <Col lg="12" md="12">
                    <div className="step-label">01</div>
                    <h4>Odabir usluge za predaju dokumentacije</h4>
                </Col>
            </Row>
            <Row className="justify-content-md-center" >
                <Col lg="12" md="12">

                    <ServiceList handleChange={props.handleChange} handleDownloadPdf={props.handleDownloadPdf} uslugaGrupaList={props.uslugaGrupaList} listToShow={props.listToShow}
                        filterList={props.filterList} validated={props.validated}
                        uslugePicked={props.uslugePicked} pickedUslugaId={props.pickedUslugaId} />
                </Col>
            </Row>
            <Row className="justify-content-md-center" >
                <Col lg="12" md="12">
                    <div className='document'>
                        <DocumentUpload selectedFiles={props.selectedFiles} showAlert={props.showAlert} alertMsg={props.alertMsg} handleFile={props.handleFile} handleDelete={props.handleDelete} requiredField={props.requiredField} showAdditionalField={props.showAdditionalField} />

                        {props.showAdditionalField === 1 ?
                            <React.Fragment>
                                <Form.Group className='grupa' controlId="dodatniUnos">
                                    <Form.Label>{props.dodatniUnosLabela}</Form.Label>
                                    <Form.Control as="textarea" rows="3" required={props.requiredField} placeholder="Unesite Vaš zahtjev" name="dodatniUnos" maxLength="2000" onChange={e => props.handleChange(e)} />
                                    <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos zahtjeva.</Form.Control.Feedback>
                                </Form.Group>
                            </React.Fragment> : null}

                        {props.showAdditionalField === 1 && props.validated === true && props.requiredField === true ?
                            <Row className="justify-content-center">
                                <div className="usluge-invalid" role="alert">Obavezan je odabir dokumentacije ili unos zahtjeva.</div>
                            </Row> : null
                        }
                    </div>
                    <div className="step-label">03</div>
                    <div className='form-group grupa'>
                        <h4>Kontakt podaci</h4>
                        <Form.Group controlId="imePrezime">
                            <Form.Label>Ime i prezime:</Form.Label>
                            <Form.Control required type="text" placeholder="Unesite Vaše ime i prezime" name="imePrezime" maxLength="100" onChange={e => props.handleChange(e)} />
                            <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos imena i prezimena.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="email">
                            <Form.Label>E-mail adresa:</Form.Label>
                            <Form.Control required type="email" placeholder="Unesite Vašu e-mail adresu" name="email" maxLength="100" onChange={e => props.handleChange(e)} pattern=".+@.+\..+" />
                            <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos ispravne e-mail adrese.</Form.Control.Feedback>
                            {props.mail === 1 ?
                                <span><i>Ukoliko prvi puta koristite OSPD, po predaji zahtjeva zaprimiti ćete e-mail za verifikaciju adrese. Molimo Vas da verificirate e-mail adresu kako biste primali obavijesti o promjeni statusa Vašeg zahtjeva.</i></span>
                                :
                                null
                            }
                        </Form.Group>
                        <Form.Group controlId="tel">
                            <Form.Label>Broj telefona:</Form.Label>
                            <Form.Control required placeholder="Unesite Vaš broj telefona" name="tel" maxLength="30" onChange={e => props.handleChange(e)} pattern="\+{0,1}\d+\s{0,1}\d+\s{0,1}\d+" />
                            <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos ispravnog broja telefona.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="podruznica">
                            <Form.Label>Odaberite Vama najbližu Fininu lokaciju:</Form.Label>
                            <Form.Control required as="select" custom="true" name="podruznica" onChange={e => props.handleChange(e)}>
                                <option></option>
                                {podruznicaOptions}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos Vama najbliže Finine lokacije.</Form.Control.Feedback>
                        </Form.Group>
                    </div>

                    <div className="step-label">04</div>

                    <h4>Podaci za provjeru statusa predanog zahtjeva</h4>
                    <Form.Group className="tajni-kod grupa" controlId="kod">
                        <Form.Label>Unesite proizvoljan tajni kod koji ćete koristiti za naknadnu provjeru statusa predanog zahtjeva:</Form.Label>
                        <InputGroup>
                            <Form.Control required type={passwordShown ? "text" : "password"} placeholder="Unesite tajni kod" name="kod" maxLength="30" onChange={e => props.handleChange(e)}
                                pattern={SECRET_REGEX_PATTERN} />
                            <InputGroup.Append onClick={togglePasswordVisiblity} style={{ "cursor": "pointer" }}>
                                <InputGroup.Text >{passwordShown ? <EyeSlashFill /> : <EyeFill />}</InputGroup.Text>
                            </InputGroup.Append>
                            <Form.Control.Feedback type="invalid" role="alert">Tajni kod mora sadržavati minimalno 8 znakova, veliko slovo, malo slovo, znamenku i specijalni znak.</Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group controlId="suglasan">
                        <Form.Check type="checkbox" >
                            <Form.Check.Input required name="suglasan" onChange={e => props.handleChange(e)} />
                            <Form.Label>Prihvaćam <span tabIndex="0" className="zahtjev-tos" onKeyPress={e => { if (e.key === 'Enter') { props.handleDownloadTos(e) } }} onClick={props.handleDownloadTos}>Opće uvjete korištenja</span></Form.Label>
                            <Form.Control.Feedback type="invalid" role="alert">Potrebno je prihvatiti Opće uvjete korištenja aplikacije.</Form.Control.Feedback>
                        </Form.Check>
                    </Form.Group>

                    <div className="d-flex">
                        <Button className='btn-zahtjev' disabled={props.isLoading} type="submit">{props.isLoading ?
                            <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner> : ''}Predaj zahtjev </Button>
                    </div>


                    <br />
                </Col>
            </Row>
        </Form >
    )
}

export default ZahtjevInputForm
